
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

interface ICategory {
  code: string,
  heroTitle?: string,
  image?: string,
  title: string,
  url: string,
  parentId?: string,
  navigationIcon?: string
}

@Component({
  template: `
    <article class='container'>
      <div class='theme-subcategories-headline'>
        <h2>{{ this.titleStart }} <span>{{ this.activetitle }}</span> {{ this.titleEnd }} <i class="icons8-chevron-down"></i></h2>
      </div>
      <div class='subcategories-overview'>
        <a v-for='theme in this.currentThemeCategories' class='category' :href='theme.url'>
          <img v-if='theme.image != null && theme.image != ""' class='image' :src='theme.image' :alt='theme.title'>
          <div v-else class='image'></div>
          <div class='bottom flex flex-align-center flex-justify-center'>
            <div class='title gray3--text text-center'>{{ theme.title }}</div>
          </div>
          <i class="icons8-chevron-down-2 flex-align-center category__icon hidden-desktop hidden-tablet"></i>
        </a>
      </div>
    </article>`
})

export default class ThemaCategories extends Vue {
  @Prop() themeCategories: ICategory[]
  @Prop({ default: '' }) themeTitle: string
  @Prop({ default: 'Our' }) titleStart: string
  @Prop({ default: 'products' }) titleEnd: string

  currentThemeCategories: ICategory[] = []
  activetitle = ''

  created() {
    this.currentThemeCategories = this.themeCategories
    this.activetitle = this.themeTitle
  }
}
